'use client';

import type { Section } from '../../entities';

export interface SectionMenuButtonProps {
  section: Section;
  open: boolean;
  onOpen: () => void;
}

export const SectionMenuButton = ({ section, open, onOpen }: SectionMenuButtonProps) => (
  <button
    className="relative inline-flex h-16 cursor-pointer items-center whitespace-nowrap border-0 bg-transparent px-3 font-[inherit] text-sm font-semibold tracking-[-0.005em] text-[var(--hubnav-fg)] transition-colors duration-150 ease-out after:absolute after:bottom-[-1px] after:left-3 after:right-3 after:h-0.5 after:origin-center after:scale-x-0 after:rounded-t after:bg-[var(--hubnav-accent)] after:content-[''] after:transition-transform after:duration-200 after:ease-[cubic-bezier(0.2,0.7,0.2,1)] hover:text-[var(--hubnav-hover-text)] focus-visible:rounded-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-8px] focus-visible:outline-[var(--hubnav-accent)] data-[open=true]:text-[var(--hubnav-hover-text)] data-[open=true]:after:scale-x-100 motion-reduce:after:transition-none"
    type="button"
    aria-expanded={open}
    data-open={open}
    onMouseEnter={onOpen}
    onFocus={onOpen}
  >
    <span className="max-[1400px]:hidden">{section.label}</span>
    <span className="hidden max-[1400px]:inline">{section.shortLabel ?? section.label}</span>
  </button>
);
